<template>
	<div v-if="value" :class="messageClass" v-html="value" />
</template>

<script>
	export default {
		props: {
			type: String,
			value: String
		},
		data() {
			return {
				types: [
					'success',
					'warning',
					'error',
					'info'
				]
			}
		},
		computed: {
			messageClass() {
				const hasType = this.type && (this.types.indexOf(this.type) !== -1);

				if (hasType) {
					return `global-message--${this.type}`;
				} else {
					return 'global-message--error';
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";
	@import "~sass/partials/_vertical-rhythm.scss";
	@import "~sass/partials/_vertical-rhythm-eoi.scss";

	.global-message {
		@extend .o-v-rhythm--small;

		text-align: center;
		padding: 21px 20px;
		font-size: 16px;
		line-height: 19px;

		&--success {
			@extend .global-message;

			color: $col-positive--2;
			background-color: $col-positive--4;
			border: 1px solid $col-positive--3;
		}

		&--warning {
			@extend .global-message;

			color: $col-warn--2;
			background-color: $col-warn--4;
			border: 1px solid $col-warn--3;
		}

		&--error {
			@extend .global-message;

			color: $col-negative--2;
			background-color: $col-negative--4;
			border: 1px solid $col-negative--3;
		}

		&--info {
			@extend .global-message;

			color: $col-t--5;
			background-color: $col-t--3;
			border: 1px solid $col-t--4;
		}
	}
</style>